import React from "react";

const stroke = (paths, extra = {}) => ({ className = "h-[13px] w-[13px]", ...rest }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={extra.strokeWidth || 2} className={className} aria-hidden="true" {...rest}>
    {paths}
  </svg>
);

const fill = (paths) => ({ className = "h-[13px] w-[13px]", ...rest }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" {...rest}>
    {paths}
  </svg>
);

export const PinIcon = stroke(<path d="M9 3h6l-1 6 4 3v2H6v-2l4-3zM12 14v7" />);
export const PinFilledIcon = fill(<path d="M9 3h6l-1 6 4 3v2H6v-2l4-3zM11 14h2v7h-2z" />);
export const EditIcon = stroke(<><path d="M4 20h4l10-10-4-4L4 16z" /><path d="m13 7 4 4" /></>);
export const ArchiveIcon = stroke(<path d="M3 5h18v4H3zM5 9v10h14V9M10 13h4" />);
export const KebabIcon = fill(<><circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" /></>);
export const CheckIcon = stroke(<path d="m5 12 4 4 10-10" />, { strokeWidth: 3 });
export const SortIcon = stroke(<path d="m8 9 4-4 4 4M8 15l4 4 4-4" />);
export const SearchIcon = stroke(<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>);
export const FilterIcon = stroke(<path d="M4 6h16M7 12h10M10 18h4" />);
export const ChevronIcon = stroke(<path d="m6 9 6 6 6-6" />);
export const PlusIcon = stroke(<path d="M12 5v14M5 12h14" />, { strokeWidth: 2.2 });
export const CloseIcon = stroke(<path d="M6 6l12 12M18 6 6 18" />);
export const PlayIcon = fill(<path d="M8 5v14l11-7z" />);
